
































import {Component, Prop, Vue} from 'vue-property-decorator';
import {EventItem} from '@/store/models';
import user from '@/store/modules/user';

@Component
export default class StartDocumentItem extends Vue {
  @Prop() event: EventItem | undefined;

  async gotoItem() {
    if (!this.event) {
      return;
    }
    await user.setSelectedDocument(this.event.Id);
    await user.setSelectedDocumentBlob(null);
    await user.setActiveExternalUser(this.event.UserIdEx);
    if (this.event && this.event.SubType === 'deck-template') {
      const OrgNr: string = '00';
      this.$router.push({name: 'templates', params: {OrgNr}});
    } else {
      const OrgNr: string = this.event.OrgNr;
      this.$router.push({name: 'documents', params: {OrgNr}});
    }
  }

  get documentType() {
    let type = '';
    if (this.event && this.event.SubType === 'deck-template') {
      type = 'mall';
    } else {
      type = 'presentation';
    }

    if (this.sharedBy) {
      return 'Mottagen ' + type;
    } else if (this.isUpdated) {
      return 'Sparad ' + type;
    }
    return 'Skapad ' + type;
  }

  get sharedBy() {
    if (!this.event || !this.event.SharedBy) {
      return undefined;
    }
    return this.event.SharedBy.UserId;
  }

  get isUpdated(): boolean {
    if (!this.event) {
      return false;
    }
    return this.event.Updated;
  }

  get documentName() {
    if (!this.event) {
      return '';
    }

    switch (this.event.SubType) {
      case 'valuation':
        return 'Förenklad kassaflödesvärdering';
      case 'company':
        return 'Bolagsanalys';
      case 'competitors':
        return 'Konkurrentjämförelse';
      case 'closingmeeting':
        return 'Bokslutsmöte';
      case 'preclosingmeeting':
        return 'Inför Bokslut';
      case 'futuremeeting':
        return 'Framtidsmöte';
      case 'yearendmeeting':
        return 'Årsavslutsmöte';
      case 'yearreview':
        return 'Årsgenomgång';
      case 'cashflow':
        return 'Kassaflödesanalys';
      case 'flexible':
        return 'Flexibel presentation';
      case 'industryAnalysis':
        return 'Branschjämförelse';
      case 'competitorAnalysis':
        return 'Konkurrentjämförelse';
      case 'webreport_cashflow':
        return 'Grundlig kassaflödesgenomgång';
      case 'preClosingMeeting':
        return 'Inför Bokslut';
      case 'deck-template':
      case 'deck':
        return this.event.Title;
    }

    return '';
  }
}
